import { type BitkitContentWidth } from '@bitrise/bitkit-v2';
import { Box, BoxProps } from '@chakra-ui/react/box';
import { createContext, ReactNode } from 'react';

/** The page content width, padding included: a `layout/maxWidth` token, for the page headers and plain `Box`es alike. */
export const CONTENT_MAX_WIDTH: BitkitContentWidth = 'layout/maxWidth/1616';

/**
 * The width of the sidebar the content column starts against, set by a layout that lays the
 * column out beside a fixed sidebar. A header stuck from inside that column offsets by it, so the
 * stuck row stays over the column instead of running over the sidebar.
 */
export const SidebarInsetContext = createContext<string | undefined>(undefined);

interface Props extends BoxProps {
  children: ReactNode;
}

const ContentWrapper = ({ children, ...rest }: Props) => {
  return (
    <Box width="100%" maxWidth={CONTENT_MAX_WIDTH} marginX="auto" paddingX={['16', '32']} {...rest}>
      {children}
    </Box>
  );
};

export default ContentWrapper;
